import { useEffect, useState } from "react";
import RadioButtonOption from './RadioButtonOption';
import axiosClient from "../../../axios-client.js";

const RadioContainerLang = ({ classInput, onClickLang, onInputValueChange }) => {
    const [selectedOption, setSelectedOption] = useState();
    const [lang, setLangs] = useState([]);
    const [nameBroadcast, setNameBroadcast] = useState(''); // Initialize with an empty string
    const [loading, setLoading] = useState(false);

    const handleSelect = (optionId, langTitle) => {
        setSelectedOption(optionId);
        onClickLang(optionId, langTitle);
    };

    const handleInputChange = (event) => {
        onInputValueChange(event);
        const inputValue = event.target.value;
        setNameBroadcast(inputValue);

        // Call the callback function to send the input value to the parent component (NewBroadcast)
        if (onInputValueChange) {
            onInputValueChange(inputValue);
        }
    };

    useEffect(() => {
        getLangs();
    }, []);

    const getLangs = () => {
        setLoading(true);
        axiosClient.get('/languages')
            .then(({ data }) => {
                setLoading(false);
                setLangs(data.data);
            })
            .catch(() => {
                setLoading(false);
            });
    };

    return (
        <div className='container-fluid p-0 m-0'>
            <div className='my-2 p-5 d-flex justify-content-center align-items-center'>
                <div className='radio-container'>
                    {lang.map((langItem) => (
                        <RadioButtonOption
                            key={langItem.id}
                            id={langItem.id}
                            imageSrc={langItem.flag}
                            langTitle={langItem.language}
                            selected={selectedOption === langItem.id}
                            onSelect={(optionId) => handleSelect(optionId, langItem.language)}
                        />
                    ))}
                </div>
            </div>
            <div className='d-flex justify-content-center align-items-center'>
                <input
                    required
                    onChange={handleInputChange}
                    value={nameBroadcast}
                    className={`${classInput} w-50 form-control rounded-pill`}
                    placeholder='Broadcast Name'
                    type='text'
                    name=''
                    id=''
                />
            </div>
        </div>
    );
};

export default RadioContainerLang;
